module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGPo6ar7TwlmGDVg1IBRA4aLAQBD9pMfdDjgnAAAAABJRU5ErkJggg=="